import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1066bfe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SuccessStoryLink: require('/home/runner/work/marketing/marketing/components/SuccessStoryLink.vue').default,LargeAccordion: require('/home/runner/work/marketing/marketing/components/LargeAccordion.vue').default})
